import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_table_graph = _resolveComponent("table-graph");
  const _component_error_wrapper = _resolveComponent("error-wrapper");
  return _openBlock(), _createBlock(_component_error_wrapper, {
    showError: $data.showError,
    onRetry: $options.retry
  }, {
    default: _withCtx(() => [_createVNode(_component_table_graph, {
      onSortTable: $options.sortTable,
      graphId: $data.graphId,
      graphTitle: $options.graphTitle,
      graphHeaders: $data.graphHeaders,
      tableLoading: $data.graphLoading,
      pageRenderedLoading: $data.pageRenderedLoading,
      positions: _ctx.graph,
      totalPositions: $data.totalPositions,
      minMax: $data.minMax,
      totalLoading: $data.totalLoading,
      description: $data.graphDescription,
      sortBy: $data.sortBy,
      sortDirection: $data.sortDirection,
      totalCount: $data.totalPositionsCount,
      currentPage: $data.currentPage,
      pageSize: $data.pageSize,
      onPage: $options.handlePage,
      dataWidths: $data.totalWidths,
      setStriped: true,
      displayTotal: true
    }, null, 8, ["onSortTable", "graphId", "graphTitle", "graphHeaders", "tableLoading", "pageRenderedLoading", "positions", "totalPositions", "minMax", "totalLoading", "description", "sortBy", "sortDirection", "totalCount", "currentPage", "pageSize", "onPage", "dataWidths"])]),
    _: 1
  }, 8, ["showError", "onRetry"]);
}